import { IFlightOnlineBookingList } from "libs/data-access/types";

export const manageFlightCharges = (flightTicket: IFlightOnlineBookingList) => {

    let charges: {
        bookingId: number;
        supplierCharge: number | null;
        cancellationCharge: number | null;
        cancellationChargeGst: number | null;
    }[] = [];

    flightTicket.bookingResponses.forEach(
        booking => {
            // for galileo
            const galCharges = booking.galileoBookingDetailResponses?.map(
                (journey) => ({
                    bookingId: booking.id,
                    supplierCharge: journey.cancellationChargeResponse.supplierCharge ?? null,
                    cancellationCharge: journey.cancellationChargeResponse.cancellationCharge ?? null,
                    cancellationChargeGst: journey.cancellationChargeResponse.cancellationChargeGst ?? null
                }));
            // for navitaire
            const navCharges = booking.navitaireBookingDetailResponses?.map(
                (journey) => ({
                    bookingId: booking.id,
                    supplierCharge: journey.cancellationChargeResponse.supplierCharge ?? null,
                    cancellationCharge: journey.cancellationChargeResponse.cancellationCharge ?? null,
                    cancellationChargeGst: journey.cancellationChargeResponse.cancellationChargeGst ?? null
                }));
            // for akbar
            const akbarCharges = booking.akbarBookingDetailResponses?.map(
                (journey) => ({
                    bookingId: booking.id,
                    supplierCharge: journey.cancellationChargeResponse?.supplierCharge ?? null,
                    cancellationCharge: journey.cancellationChargeResponse?.cancellationCharge ?? null,
                    cancellationChargeGst: journey.cancellationChargeResponse?.cancellationChargeGst ?? null
                }));

            if (galCharges) charges.push(...galCharges);
            if (navCharges) charges.push(...navCharges);
            if (akbarCharges) charges.push(...akbarCharges);
        }
    );

    // console.log("Charges: ", charges);

    return charges;
};